/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateTenantDto } from '../models/work-create-tenant-dto';
import { WorkExternalTenantProjectOverviewDto } from '../models/work-external-tenant-project-overview-dto';
import { WorkTenant } from '../models/work-tenant';
import { WorkUpdateTenantDto } from '../models/work-update-tenant-dto';

@Injectable({ providedIn: 'root' })
export class WorkTenantsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `tenantsV2ControllerTriggerSync()` */
  static readonly TenantsV2ControllerTriggerSyncPath = '/v2/tenants/tenants/trigger-sync';

  /**
   * Manually trigger tenant link synchronization (TESTING ONLY).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantsV2ControllerTriggerSync()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantsV2ControllerTriggerSync$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsV2Service.TenantsV2ControllerTriggerSyncPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Manually trigger tenant link synchronization (TESTING ONLY).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantsV2ControllerTriggerSync$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantsV2ControllerTriggerSync(
    params?: {
    },
    context?: HttpContext
  ): Observable<void> {
    return this.tenantsV2ControllerTriggerSync$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `tenantsV2ControllerFindAll()` */
  static readonly TenantsV2ControllerFindAllPath = '/v2/tenants/tenants';

  /**
   * Required permissions: tenants:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantsV2ControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantsV2ControllerFindAll$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTenant>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsV2Service.TenantsV2ControllerFindAllPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTenant>>;
      })
    );
  }

  /**
   * Required permissions: tenants:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantsV2ControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantsV2ControllerFindAll(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkTenant>> {
    return this.tenantsV2ControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTenant>>): Array<WorkTenant> => r.body)
    );
  }

  /** Path part for operation `tenantsV2ControllerCreate()` */
  static readonly TenantsV2ControllerCreatePath = '/v2/tenants/tenants';

  /**
   * Required permissions: tenants:create
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantsV2ControllerCreate$Response(
    params: {
      body: WorkCreateTenantDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTenant>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsV2Service.TenantsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTenant>;
      })
    );
  }

  /**
   * Required permissions: tenants:create
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantsV2ControllerCreate(
    params: {
      body: WorkCreateTenantDto
    },
    context?: HttpContext
  ): Observable<WorkTenant> {
    return this.tenantsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTenant>): WorkTenant => r.body)
    );
  }

  /** Path part for operation `tenantsV2ControllerHasActiveTenants()` */
  static readonly TenantsV2ControllerHasActiveTenantsPath = '/v2/tenants/tenants/has-active';

  /**
   * Required permissions: tenants:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantsV2ControllerHasActiveTenants()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantsV2ControllerHasActiveTenants$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<{
'hasActiveTenants'?: boolean;
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsV2Service.TenantsV2ControllerHasActiveTenantsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'hasActiveTenants'?: boolean;
        }>;
      })
    );
  }

  /**
   * Required permissions: tenants:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantsV2ControllerHasActiveTenants$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantsV2ControllerHasActiveTenants(
    params?: {
    },
    context?: HttpContext
  ): Observable<{
'hasActiveTenants'?: boolean;
}> {
    return this.tenantsV2ControllerHasActiveTenants$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'hasActiveTenants'?: boolean;
}>): {
'hasActiveTenants'?: boolean;
} => r.body)
    );
  }

  /** Path part for operation `tenantsV2ControllerGetExternalProjectsByTeamRoletype()` */
  static readonly TenantsV2ControllerGetExternalProjectsByTeamRoletypePath = '/v2/tenants/tenants/external-projects-by-team-roletype';

  /**
   * Required permissions: tenants:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantsV2ControllerGetExternalProjectsByTeamRoletype()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantsV2ControllerGetExternalProjectsByTeamRoletype$Response(
    params: {
      fromDate: string;
      toDate: string;
      roletypeName: string;
      calculationItemIds: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkExternalTenantProjectOverviewDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsV2Service.TenantsV2ControllerGetExternalProjectsByTeamRoletypePath, 'get');
    if (params) {
      rb.query('fromDate', params.fromDate, {});
      rb.query('toDate', params.toDate, {});
      rb.query('roletypeName', params.roletypeName, {});
      rb.query('calculationItemIds', params.calculationItemIds, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkExternalTenantProjectOverviewDto>>;
      })
    );
  }

  /**
   * Required permissions: tenants:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantsV2ControllerGetExternalProjectsByTeamRoletype$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantsV2ControllerGetExternalProjectsByTeamRoletype(
    params: {
      fromDate: string;
      toDate: string;
      roletypeName: string;
      calculationItemIds: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkExternalTenantProjectOverviewDto>> {
    return this.tenantsV2ControllerGetExternalProjectsByTeamRoletype$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkExternalTenantProjectOverviewDto>>): Array<WorkExternalTenantProjectOverviewDto> => r.body)
    );
  }

  /** Path part for operation `tenantsV2ControllerFindOne()` */
  static readonly TenantsV2ControllerFindOnePath = '/v2/tenants/tenants/{id}';

  /**
   * Required permissions: tenants:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantsV2ControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantsV2ControllerFindOne$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTenant>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsV2Service.TenantsV2ControllerFindOnePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTenant>;
      })
    );
  }

  /**
   * Required permissions: tenants:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantsV2ControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantsV2ControllerFindOne(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTenant> {
    return this.tenantsV2ControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTenant>): WorkTenant => r.body)
    );
  }

  /** Path part for operation `tenantsV2ControllerUpdate()` */
  static readonly TenantsV2ControllerUpdatePath = '/v2/tenants/tenants/{id}';

  /**
   * Required permissions: tenants:update
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateTenantDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTenant>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsV2Service.TenantsV2ControllerUpdatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTenant>;
      })
    );
  }

  /**
   * Required permissions: tenants:update
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateTenantDto
    },
    context?: HttpContext
  ): Observable<WorkTenant> {
    return this.tenantsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTenant>): WorkTenant => r.body)
    );
  }

  /** Path part for operation `tenantsV2ControllerRemove()` */
  static readonly TenantsV2ControllerRemovePath = '/v2/tenants/tenants/{id}';

  /**
   * Required permissions: tenants:delete
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantsV2ControllerRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantsV2ControllerRemove$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsV2Service.TenantsV2ControllerRemovePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: tenants:delete
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantsV2ControllerRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantsV2ControllerRemove(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.tenantsV2ControllerRemove$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
